import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import ManagePaymentActionCreator from '../actions/ManagePaymentActionCreator';
import HashcodeUtils from './HashcodeUtils';

const _getPaymentUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/mandates/';
const _getSOPaymentUrl = `${_getPaymentUrl}${'so'}`;
const _getDDPaymentUrl = `${_getPaymentUrl}${'dd'}`;
const _delPaymentUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/mandates/';
const _updatePaymentEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/mandates/so/';

export default class ManagePaymentsApiUtils {
  /**
   * API call for getDirectDebitPaymentList.
   * Retrieves the list of direct payments for a particular account.
   */
  static getDirectDebitPaymentList(accountId, accountName, accountNumber) {
    const getDDPaymentUrl = _getDDPaymentUrl.replace('{account_id}', accountId);
    let url = envConfig.apiBaseUrlPAAS + getDDPaymentUrl;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.DirectDebitListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.mandateService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        const responseBody = body;
        if (!responseBody) {
          ManagePaymentActionCreator.setPaymentListFailure();
        } else {
          responseBody.accountId = accountId;
          responseBody.accountName = accountName;
          responseBody.accountNumber = accountNumber;
          ManagePaymentActionCreator.setDDListSuccess(responseBody);
        }
      },
      (error) => {
        ManagePaymentActionCreator.setPaymentListFailure(error);
      }
    );
  }

  /**
   * API call for getStandingOrderPaymentList.
   * Retrieves the list of payments for a particular account.
   */
  static getStandingOrderPaymentList(accountId, accountName, accountNumber) {
    const getSOPaymentUrl = _getSOPaymentUrl.replace('{account_id}', accountId);
    let url = envConfig.apiBaseUrlPAAS + getSOPaymentUrl;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.MandateListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.mandateService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        const responseBody = body;
        if (!responseBody) {
          ManagePaymentActionCreator.setPaymentListFailure();
        } else {
          responseBody.accountId = accountId;
          responseBody.accountName = accountName;
          responseBody.accountNumber = accountNumber;
          ManagePaymentActionCreator.setSOListSuccess(responseBody);
        }
        //	ManagePaymentPP
      },
      (error) => {
        ManagePaymentActionCreator.setPaymentListFailure(error);
      }
    );
  }

  static cancelPayment(deletePaymentRequest) {
    let deleteUrl = _delPaymentUrl.replace(
      '{account_id}',
      deletePaymentRequest.fromAccountId
    );
    deleteUrl = `${deleteUrl + deletePaymentRequest.category.toLowerCase()}/${
      deletePaymentRequest.id
    }`;

    let url = envConfig.apiBaseUrlPAAS + deleteUrl;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.DeletedPaymentConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.mandateService,
        method: envConfig.stubConfig ? 'Get' : 'DELETE',
        url,
        addAuthToken: true,
      },
      (body) => {
        // Handling the success response
        const success = {
          code: 201,
        };
        ManagePaymentActionCreator.cancelPaymentResponse(success);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          ManagePaymentActionCreator.cancelPaymentResponse(error);
        } else {
          ManagePaymentActionCreator.cancelPaymentResponse({ code: 422 });
        }
      }
    );
  }

  static editPayment(data, accountId, mandateId, isSameSourceId) {
    const updatePaymentUrl = _updatePaymentEndpoint.replace(
      '{account_id}',
      accountId
    );
    let url = envConfig.apiBaseUrlPAAS + updatePaymentUrl + mandateId;
    const requestData = data;

    if (isSameSourceId) {
      requestData.source_id = HashcodeUtils.getSourceIdForSoftToken();
    } else requestData.source_id = HashcodeUtils.getSourceId(requestData);
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.SOPaymentUpdateConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.mandateService,
        method: envConfig.stubConfig ? 'Get' : 'PUT',
        url,
        requestData,
        addAuthToken: true,
      },
      (bodys) => {
        const body = bodys;
        body.code = 201;
        ManagePaymentActionCreator.updateEditPaymentStatus(body);
      },
      (errors) => {
        const error = errors;
        error.code = 422;
        ManagePaymentActionCreator.updateEditPaymentStatus(error);
      }
    );
  }
}
